@if (onboardingData()) {
  <div class="onboarding-container mobile-project-container" *transloco="let t">
    <div class="content">
      <div class="campaigns-list-container">
        <div class="page-counter">{{ currentPage }}/{{ maxPages }}</div>
        @switch (currentPage) {
          @case (1) {
            <app-first-page [companyName]="onboardingData().merchantName!"
                            [loyaltyScore]="onboardingData().loyaltyScore!"
                            [companyLogo]="onboardingData().merchantLogo!">
            </app-first-page>
          }
          @case (2) {
            <app-second-page [companyName]="onboardingData().merchantName!" [amountSpent]="onboardingData().amountSpent"
                             [companyLogo]="onboardingData().merchantLogo!">
            </app-second-page>
          }
          @case (3) {
            <app-third-page [companyName]="onboardingData().merchantName!" [firstVisit]="onboardingData().firstVisit"
                            [companyLogo]="onboardingData().merchantLogo!">
            </app-third-page>
          }
          @case (4) {
            <app-fourth-page [companyName]="onboardingData().recommendedCampaign?.merchantName!"
                             [cashbackPercent]="onboardingData().recommendedCampaign?.reward"
                             [companyLogo]="onboardingData().recommendedCampaign?.merchantLogo!"></app-fourth-page>
          }
          @case (5) {
            <app-fifth-page [loyaltyLevelAggregations]="onboardingData().loyaltyLevelAggregations"></app-fifth-page>
          }
        }
        <div class="buttons-container">
          @if (currentPage == maxPages) {
            <button mat-stroked-button class="button-medium" (click)="markOnboardingStatusAsDisplayed()">
              {{ t('onboarding.buttons.revealPlaces', {allPlacesCount: allPlacesCount()}) }}
            </button>
          } @else {
            <button mat-button class="button-medium back-button" (click)="goBack()">
              {{ t('onboarding.buttons.back') }}
            </button>
            <button mat-stroked-button class="button-medium" (click)="goToNextPage()">
              {{ t('onboarding.buttons.continue') }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
